






import { defineComponent, onBeforeUnmount, ref } from "@vue/composition-api";
import emitter from "@/lib/emitter";
import AgeVerification from "../components/AgeVerification";
import { EVENTS, GateRequestPayload, NsfwVerificationType } from "../const";

type ControllerState = "IDLE" | "VERIFYING";

export default defineComponent({
  name: "AgeVerificationController",
  components: { AgeVerification },
  setup() {
    const state = ref<ControllerState>("IDLE");
    const verificationType = ref<NsfwVerificationType>("yoti");

    let pendingOnResult: ((verified: boolean) => void) | undefined;

    const resolveVerification = (verified: boolean) => {
      pendingOnResult?.(verified);
      pendingOnResult = undefined;
      state.value = "IDLE";
    };

    const startGate = (payload?: GateRequestPayload) => {
      pendingOnResult = payload?.onResult;
      verificationType.value = payload?.verificationType ?? "yoti";
      state.value = "VERIFYING";
    };

    const onYotiClose = (verified?: boolean) => resolveVerification(!!verified);

    emitter.on<GateRequestPayload>(EVENTS.SENSITIVE_CONTENT_GATE_REQUEST, startGate);
    onBeforeUnmount(() => {
      emitter.off<GateRequestPayload>(EVENTS.SENSITIVE_CONTENT_GATE_REQUEST, startGate);
    });

    return {
      state,
      verificationType,
      onYotiClose,
    };
  },
});
